var TESNAV = TESNAV || {};

TESNAV.requestProfile = function() {

  if ((typeof Cookies !== 'undefined') && !Cookies.get('TESCookieUser')) {
    TESNAV.$container.find('.js-profile').addClass('loaded');
    return;
  }

  function requestBalance () {
    jQuery.ajax({url: '/api/payments/v1/balance', cache: false, dataType: 'json'})
      .then(function (balanceData) {
        var balance;
        if (balanceData && (typeof parseFloat(balanceData.amount) === 'number')) {
          balance = balanceData.symbol + balanceData.amount.toFixed(2);
          if (balance) {
            TESNAV.$container.find('.js-balance').text(balance);
          }
        }
      });
  }

  // get login status / profile information
  jQuery.ajax({url: "/api/v1/member/profile", cache: false, dataType: 'json'})
    .done(function (data) {
      var profile;
      try {
        if (data != null) {
          // add cache busting to the url as the service isn't doing it anymore.
          data.avatarSmall = data.avatarSmall + '?_=' + new Date().getTime();
          profile = TES.templates['header-profile-v3'](data);
          TESNAV.$container.find('.js-profile').html(profile);
          requestBalance();
          TESNAV.notifications();
        }
      } catch (e) {
        if(window.console && window.console.log) console.log(e);
      }
    })
    .complete(function () {
      TESNAV.$container.find('.js-profile').addClass('loaded');
    });
};
